export default "__VITE_ASSET__Do8Ru7MA__"